import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[option-tmp]' })
export class OptionTemplateDirective {
    constructor(public template: TemplateRef<any>) {
    }
}
@Directive({ selector: '[selected-tmp]' })
export class SelectedItemTemplateDirective {
    constructor(public template: TemplateRef<any>) {
    }
}


// WEBPACK FOOTER //
// ./src/app/components/select-helpper/select-helpper.directive.ts